import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';
import { FadeIn } from './lib/fade-in';

export type FadeContainerProps = NodeProps<{
  children: StructuredContent | StructuredContent[];
  offset?: number;
}>;

export function FadeContainer({ props }: FadeContainerProps) {
  return (
    <FadeIn offset={props.offset}>
      <StructuredContentRenderer doc={props.children} />
    </FadeIn>
  );
}
